"use strict";
/* eslint-disable no-new-func */
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildOptions = exports.buildShouldFetch = exports.buildJsonObj = exports.getRuntimeValueFromConfig = exports.getRuntimeBaseValue = exports.getRuntimeJsValue = exports.transformBoolStr = exports.transformFunction = exports.transformExpression = void 0;
var lowcode_types_1 = require("@alilc/lowcode-types");
function isObject(obj) {
    return Object.prototype.toString.call(obj).indexOf('Object') !== -1;
}
var transformExpression = function (code, context) {
    // 补充异常情况兼容性
    if (code === undefined) {
        return function () { };
    }
    if (code === '') {
        return function () { return ''; };
    }
    try {
        return new Function("return (".concat(code, ")")).call(context);
    }
    catch (error) {
        console.error("transformExpression error, code is ".concat(code, ", context is ").concat(context, ", error is ").concat(error));
    }
};
exports.transformExpression = transformExpression;
var transformFunction = function (code, context) {
    if (code === undefined) {
        return function () { };
    }
    if (code === '') {
        return function () { return ''; };
    }
    try {
        return new Function("return (".concat(code, ")")).call(context).bind(context);
    }
    catch (error) {
        console.error("transformFunction error, code is ".concat(code, ", context is ").concat(context, ", error is ").concat(error));
    }
};
exports.transformFunction = transformFunction;
var transformBoolStr = function (str) {
    return str !== 'false';
};
exports.transformBoolStr = transformBoolStr;
var getRuntimeJsValue = function (value, context) {
    if (!['JSExpression', 'JSFunction'].includes(value.type)) {
        console.error("translate error, value is ".concat(JSON.stringify(value)));
        return '';
    }
    // TODO: 类型修复
    var code = value.compiled || value.value;
    return value.type === 'JSFunction' ? (0, exports.transformFunction)(code, context) : (0, exports.transformExpression)(code, context);
};
exports.getRuntimeJsValue = getRuntimeJsValue;
var getRuntimeBaseValue = function (type, value) {
    switch (type) {
        case 'string':
            return "".concat(value);
        case 'boolean':
            return typeof value === 'string' ? (0, exports.transformBoolStr)(value) : !!value;
        case 'number':
            return Number(value);
        default:
            return value;
    }
};
exports.getRuntimeBaseValue = getRuntimeBaseValue;
var getRuntimeValueFromConfig = function (type, value, context) {
    if (value === undefined) {
        return undefined;
    }
    if ((0, lowcode_types_1.isJSExpression)(value) || (0, lowcode_types_1.isJSFunction)(value)) {
        return (0, exports.getRuntimeBaseValue)(type, (0, exports.getRuntimeJsValue)(value, context));
    }
    return value;
};
exports.getRuntimeValueFromConfig = getRuntimeValueFromConfig;
var buildJsonObj = function (params, context) {
    if ((0, lowcode_types_1.isJSExpression)(params)) {
        return (0, exports.transformExpression)(params.value, context);
    }
    else if (isObject(params)) { // 处理params内部为JSExpression的问题
        var newParams = {};
        for (var _i = 0, _a = Object.entries(params); _i < _a.length; _i++) {
            var _b = _a[_i], name_1 = _b[0], param = _b[1];
            if ((0, lowcode_types_1.isJSExpression)(param)) {
                newParams[name_1] = (0, exports.transformExpression)(param === null || param === void 0 ? void 0 : param.value, context);
            }
            else if (isObject(param)) {
                newParams[name_1] = (0, exports.buildJsonObj)(param, context);
            }
            else {
                newParams[name_1] = param;
            }
        }
        return newParams;
    }
    return params;
};
exports.buildJsonObj = buildJsonObj;
var buildShouldFetch = function (ds, context) {
    if (!ds.options || !ds.shouldFetch) {
        return true; // 默认为 true
    }
    if ((0, lowcode_types_1.isJSExpression)(ds.shouldFetch) || (0, lowcode_types_1.isJSFunction)(ds.shouldFetch)) {
        return (0, exports.getRuntimeJsValue)(ds.shouldFetch, context);
    }
    return (0, exports.getRuntimeBaseValue)('boolean', ds.shouldFetch);
};
exports.buildShouldFetch = buildShouldFetch;
var buildOptions = function (ds, context) {
    var options = ds.options;
    if (!options)
        return undefined;
    // eslint-disable-next-line space-before-function-paren
    return function () {
        // 默认值
        var fetchOptions = {
            uri: '',
            params: {},
            method: 'GET',
            isCors: true,
            timeout: 5000,
            headers: undefined,
            v: '1.0',
        };
        Object.keys(options).forEach(function (key) {
            switch (key) {
                case 'uri':
                    fetchOptions.uri = (0, exports.getRuntimeValueFromConfig)('string', options.uri, context);
                    break;
                case 'params':
                    fetchOptions.params = (0, exports.buildJsonObj)(options.params, context);
                    break;
                case 'method':
                    fetchOptions.method = (0, exports.getRuntimeValueFromConfig)('string', options.method, context);
                    break;
                case 'isCors':
                    fetchOptions.isCors = (0, exports.getRuntimeValueFromConfig)('boolean', options.isCors, context);
                    break;
                case 'timeout':
                    fetchOptions.timeout = (0, exports.getRuntimeValueFromConfig)('number', options.timeout, context);
                    break;
                case 'headers':
                    fetchOptions.headers = (0, exports.buildJsonObj)(options.headers, context);
                    break;
                case 'v':
                    fetchOptions.v = (0, exports.getRuntimeValueFromConfig)('string', options.v, context);
                    break;
                default:
                    // 其余的除了做表达式或者 function 的转换，直接透传
                    fetchOptions[key] = (0, exports.getRuntimeValueFromConfig)('unknown', options[key], context);
            }
        });
        return fetchOptions;
    };
};
exports.buildOptions = buildOptions;
